export const errorStyle = 'mt-2 ml-4 text-xs font-light text-red-500 block';
export const labelStyle =
  'mt-2 block text-xs font-light leading-5 text-white mb-1 ml-4 opacity-75';
